import { Operation, Range, Node, Editor } from 'domains/reporter/RichTextEditor/core';
import pick from 'ramda/es/pick';
import type { HistoryType } from '../core';

export type PartialEditor = {
  children: Node[];
  selection: Range | null;
  operations: Operation[];
  log?: {
    ops: Operation[];
  };
  history?: HistoryType;
};

/*
 * This function return an editor-like object which has been stripped of
 * editor methods.
 * Useful only for logging purposes.
 */
export const partialEditor = (editor: Editor): PartialEditor =>
  pick(['children', 'operations', 'selection'], editor) as PartialEditor;
